// extracted by mini-css-extract-plugin
module.exports = {"btnWishlist":"WishlistButton_btnWishlist__wVDAW","btnWishlistclick":"WishlistButton_btnWishlistclick__fftiE","btnwishlistonclick":"WishlistButton_btnwishlistonclick__WwiX4"};